import {Button, Col, Modal, Row} from 'antd';
import React, {useEffect, useState} from 'react';

import {Client, User} from '../../../../libs/types/src';
import {CONSTANTS, CorePlan} from '../../../../libs/ui/src';

import background from '../../../../assets/images/invites_limit_reached_bg.png';
import './FreeInvitesLimitReached.scss';

interface FreeInvitesLimitReachedProps {
  client: Client;
  users: User[];
  activateRegularPlanGx: (updateIsLoading: any, planId: string) => void;
}

export function FreeInvitesLimitReached({
  client,
  users,
  activateRegularPlanGx,
}: Readonly<FreeInvitesLimitReachedProps>) {
  const [visible, setVisible] = useState(false);
  const hideModal = () => setVisible(false);
  const activateAccelerate = () => {
    activateRegularPlanGx(undefined, CONSTANTS.BILLING.PLANS.STARTER);
    setVisible(false);
  };
  useEffect(() => {
    if (client.type === CONSTANTS.BILLING.PLANS.FREE) {
      const user = users.find(u => !u.archived);
      const limitReached = user?.messages_sent_monthly_cur_billing_term >= user?.monthly_max_messages_limit;
      const limitReachedShown = sessionStorage.getItem('free_invites_limit_reached_shown');
      if (limitReached && !limitReachedShown) {
        setVisible(true);
        sessionStorage.setItem('free_invites_limit_reached_shown', 'true');
      }
    }
  }, [client, users]);
  return (
    <Modal open={visible} onCancel={hideModal} width={1000} footer={null}>
      <div
        className="free-invites-limit-reached"
        style={{background: `url(${background}) no-repeat center center`, backgroundSize: 'cover'}}
      >
        <div className="title">
          <h2>Oops...Your limit reached!</h2>
          <p>
            Looks like you've used up your 100 monthly invites on the Free plan! Upgrade to Accelerate for just $299/month and
            get unlimited connection invites & more.
          </p>
        </div>
        <Row justify="center" className="content">
          <Col span={12}>
            <CorePlan period="monthly" />
          </Col>
        </Row>
        <Row justify="center" className="bottom">
          <Col span={12}>
            <div className="buttons-wrapper">
              <Button type="dashed" onClick={hideModal}>
                Not Now
              </Button>
              <Button type="primary" onClick={activateAccelerate}>
                Get Accelerate Subscription!
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}
